export default "__VITE_ASSET__qs4cKaA___"